import { render, staticRenderFns } from "./comment-form.vue?vue&type=template&id=76328848&"
import script from "./comment-form.vue?vue&type=script&lang=ts&"
export * from "./comment-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76328848')) {
      api.createRecord('76328848', component.options)
    } else {
      api.reload('76328848', component.options)
    }
    module.hot.accept("./comment-form.vue?vue&type=template&id=76328848&", function () {
      api.rerender('76328848', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/microblog/comment-form.vue"
export default component.exports